import { AgreementStatus, IntervalModel } from "$models";
import type {
  _Date,
  AgreementRef,
  AgreementState,
  DateTime,
  Interval,
} from "$apis/parkito2/index.ts";

export default class AgreementRefModel implements AgreementRef {
  constructor(private _data: AgreementRef) {}

  get approvedAt(): string | undefined {
    return this._data.approvedAt ?? undefined;
  }
  get endDate(): string | undefined {
    return this._data.endDate ?? undefined;
  }
  get id(): string {
    return this._data.id;
  }
  get number(): number {
    return this._data.number;
  }
  get offerDeclinedAt(): string | undefined {
    return this._data.offerDeclinedAt ?? undefined;
  }
  get offerExpiresAt(): string | undefined {
    return this._data.offerExpiresAt ?? undefined;
  }
  get offerNoticePeriod(): Interval {
    return this._data.offerNoticePeriod ?? undefined;
  }
  get offeredAt(): DateTime | undefined {
    return this._data.offeredAt ?? undefined;
  }
  get startDate(): string | undefined {
    return this._data.startDate ?? undefined;
  }
  get state(): AgreementState {
    return this._data.state;
  }
  getState(): AgreementStatus {
    const offeredAt = this._data.offeredAt;
    const offerDeclinedAt = this._data.offerDeclinedAt;
    const approvedAt = this._data.approvedAt;
    const startDate = this._data.startDate;
    const endDate = this._data.endDate;
    const offerNoticePeriod = new IntervalModel(this._data.offerNoticePeriod);

    // Approved, Active, Ending, Ended
    if (approvedAt && startDate) {
      // Start date is in the future
      if (Date.now() < new Date(startDate).getTime()) {
        return AgreementStatus.APPROVED;
      } // Start date is today or in the past
      else if (!endDate) {
        return AgreementStatus.ACTIVE;
      } // Started, End set but not passed
      else if (Date.now() <= new Date(endDate).getTime()) {
        return AgreementStatus.ENDING;
      } // Ended
      else {
        return AgreementStatus.ENDED;
      }
    } else {
      // Draft
      if (!offeredAt) {
        return AgreementStatus.DRAFT;
      } // Offer declined
      else if (offerDeclinedAt) {
        return AgreementStatus.OFFER_DECLINED;
      } // Offered and Offer expired
      else {
        const offeredDate = new Date(offeredAt);
        const expiresAfter = new Date(offeredDate);
        // Add offerNoticePeriod (days) to the offer date
        expiresAfter.setDate(
          expiresAfter.getDate() + offerNoticePeriod.days,
        );

        if (Date.now() <= expiresAfter.getTime()) {
          return AgreementStatus.OFFERED;
        } else {
          return AgreementStatus.OFFER_EXPIRED;
        }
      }
    }
  }

  isBlockingSpot(): boolean {
    return this.getState() === AgreementStatus.ACTIVE;
  }

  getEndDate(): Date | undefined {
    return this._data.endDate
      ? new Date(Date.parse(this._data.endDate))
      : undefined;
  }
}
